module.exports = __webpack_public_path__ + "img/1.3.6b4c4f7d.jpg";